import { Trans } from 'react-i18next';
import { ListGroup, ListGroupItem } from 'reactstrap';

export interface ConfirmSummaryRow { label: string; detail: string; }

export interface StepConfirmSplitProps {
  summary: ConfirmSummaryRow[];
}

export function StepConfirmSplit({ summary }: StepConfirmSplitProps) {
  return (
    <div>
      <p className="text-muted mb-3">
        <Trans
          ns="picklist"
          i18nKey={summary.length === 1 ? 'wizard.confirm_split.intro_one' : 'wizard.confirm_split.intro_other'}
          values={{ count: summary.length }}
          components={{ strong: <strong className="text-body" /> }}
        />
      </p>
      <ListGroup flush>
        {summary.map((row, i) => (
          <ListGroupItem key={i} className="d-flex justify-content-between align-items-start px-0">
            <span className="fw-semibold">{row.label}</span>
            <span className="text-muted small ms-3 text-end">{row.detail}</span>
          </ListGroupItem>
        ))}
      </ListGroup>
    </div>
  );
}
